import React, { useEffect, useState } from "react"
import { Button, Modal } from "reactstrap"
import LoadingSpinner from "../LoadingSpinner"
import styles from "./styles.module.scss"
import { GetCharityInfo } from "../../../Code/Data"

export default function CharityDetailModal({ charity, onClose, onSelect }) {
  const [loading, setLoading] = useState(true)
  const [charityDetail, setCharityDetail] = useState()

  useEffect(() => {
    async function loadCharityDetail() {
      setLoading(true)
      setCharityDetail()

      if (charity) {
        const charityInfo = await GetCharityInfo(charity.CharityId)
        setCharityDetail(charityInfo)
      }
      setLoading(false)
    }

    charity && loadCharityDetail()
  }, [charity])

  const renderContent = () => {
    if (loading) {
      return <LoadingSpinner />
    }

    const {
      CharityName,
      CategoryName,
      Locations,
      ShortDescription,
      LongDescription,
      LogoUrl,
      Url,
      IsLocal,
    } = charityDetail

    return (
      <>
        {LogoUrl && (
          <div className={styles.header}>
            {/* <CardImgOverlay className="text-right">
            <UncontrolledDropdown onClick={e => e.stopPropagation()}>
              <DropdownToggle size="sm" color="primary" className="aaaa">
                <i className="fa fa-ellipsis-v" />
              </DropdownToggle>

              <DropdownMenu end>
                <DropdownItem
                  tag={Link}
                  to={`/Purchase?CID=${charity?.CharityId}`}>
                  Purchase
                </DropdownItem>
                <DropdownItem
                  tag={Link}
                  to={`/Purchase/HonorCards?CID=${charity?.CharityId}`}>
                  Honor Cards
                </DropdownItem>
                <DropdownItem
                  tag={Link}
                  to={`/Purchase/DirectToCharityDonation?CID=${charity?.CharityId}`}>
                  Donate Directly
                </DropdownItem>
                <DropdownItem
                  tag={Link}
                  to={`/Redeem?CID=${charity?.CharityId}`}>
                  Redeem
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </CardImgOverlay> */}
          </div>
        )}
        <div className={styles.charityName}>
          {CharityName}

          {!!onSelect && (
            <Button
              className={styles.btnSelect}
              outline
              color="primary"
              size="sm"
              onClick={() => onSelect(charity)}>
              Select Charity
            </Button>
          )}
        </div>
        {LogoUrl && (
          <img
            className={styles.img}
            width={"100px"}
            src={LogoUrl}
            onError={e => {
              e.target.onerror = null
              e.target.src = "images/default.png"
            }}
            alt={CharityName}
            style={{
              maxWidth: "110px",
              maxHeight: "100px",
              objectFit: "contain",
            }}
          />
        )}

        {Url && (
          <a
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            href={Url}>
            <i className="fa-solid fa-globe" />
            {Url}
          </a>
        )}
        {CategoryName && (
          <div className={styles.detailItem}>
            <b>Charity Category:</b> {CategoryName}
          </div>
        )}
        {IsLocal && Locations && (
          <div className={styles.detailItem}>
            <b>Location:</b> {Locations.join(", ")}
          </div>
        )}
        <div className={styles.description}>{ShortDescription}</div>
        {LongDescription && (
          <div className={styles.description}>{LongDescription}</div>
        )}
      </>
    )
  }

  return (
    <Modal
      contentClassName={styles.modalContent}
      centered
      size="lg"
      isOpen={charity}
      toggle={onClose}>
      <div className={styles.btnClose} onClick={onClose}>
        <i className="fa-solid fa-xmark" />
      </div>
      {renderContent()}
    </Modal>
  )
}
